//menu-full
$(function(){
  $('a.mobile-trigger').on('click', function(){
      $('body').toggleClass('mobile-open');
	  $('.hdr-search').slideUp();
  }) 

 $('.Fullmenu-bar .close_nav').on('click', function() {
    $('.Fullmenu-bar').removeClass('full_menu');
    $('body').removeClass('mobile-open');
  })
  
  $('.closeOfferStrip').on('click', function() {
    $('.header-top').slideUp();
  })
  
  $('a.searchM-icon').on('click', function() {
    $('.hdr-search').slideToggle();
  })
  
	$('.tAreaTxt').on('click', function() {
		$(this).find('.tAreaTxtH').hide();
	})
  
  $('.sub-Menu-hov .mob-dd').on('click', function(){
      $(this).next('.sub-Menu').slideToggle();
	  $(this).toggleClass('dd-show');
  })  
  
  $('.ftr-links h4').on('click', function(){
      $(this).parents('.ftr-links').find('li').not('li:first-child').slideToggle();
	  $(this).toggleClass('act');
	  $(this).parents('.r-pr .col-lg-2').siblings('.col-sm-12').find('li').not('li:first-child').slideUp();
	  $(this).parents('.r-pr .col-lg-2').siblings('.col-sm-12').find('h4').removeClass('act');
  })
  
  $('.SuB-fullMnArw').on('click', function(){
      $(this).find('.SuB-fullMn').css('display','block');
	  $('body').find('a.mobile-trigger').css('display','none');
	  $('body').find('a.mobile-trigger-c').css('display','inline-block');
  })
  
  $('a.mobile-trigger-c').on('click', function(){
      $('body').find('.SuB-fullMn').css('display','none');
	  $('body').find('a.mobile-trigger').css('display','block');
	  $('body').find('a.mobile-trigger-c').css('display','none');
  })
  
  $('.togSuB-fullMnArw').on('click', function(){
      $(this).find('.togSuB-fullMn').slideToggle();
	  $(this).toggleClass('act');
	  $(this).siblings('li').find('.togSuB-fullMn').slideUp();
	  $(this).siblings('li').removeClass('act');
  })
  
  $('.details-dec-top h5').on('click', function(){
    $(this).next('.description-b').slideToggle();
	  $(this).toggleClass('act');
	  //$(this).parents('.details-dec-top li').siblings('li').find('.description-b').slideUp();
	  //$(this).parents('.details-dec-top li').siblings('li').find('h5').removeClass('act');
  })
    
});


if( $(window).width() < 767 ){
	$(document).click(function(e){
	  if(!$(e.target).is('a.mobile-trigger, a.mobile-trigger *, .Fullmenu-bar, .Fullmenu-bar *, a.mobile-trigger-c, a.mobile-trigger-c *, a.searchM-icon, a.searchM-icon *, .hdr-search, .hdr-search *')){
		$('.Fullmenu-bar').removeClass('full_menu');
		$('body').removeClass('mobile-open');
		$('.hdr-search').slideUp();
	  }
	});
}


